module.exports = __webpack_public_path__ + "media/images/dropdown_arrow-0b3bcf2ec5bc595529c7e101e65af27b.svg";